import { get, del } from '../httpMethods';
import { ApiResponse } from '../../types/api';
import axios from 'axios';
import { ENV } from '../../config/env';

export interface Attachment {
  id: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  filePath: string;
  publicUrl?: string;
  entityType: string;
  entityId: string;
  description?: string;
  uploadedById?: string;
  uploadedAt?: string;
  createdAt: string;
}

export type AttachmentEntityType =
  | 'radiology_order'
  | 'radiology_report'
  | 'lab_order'
  | 'lab_result'
  | 'medical_record'
  | 'consultation'
  | 'prescription'
  | 'patient'
  | 'employee'
  | 'leave'
  | 'visit'
  | 'admission'
  | 'invoice'
  | 'emergency'
  | 'nursing_note'
  | 'ot_schedule'
  | 'diagnostic_test'
  | 'diagnostic_department'
  | 'diagnostic_accessory'
  | 'diagnostic_receipt'
  | 'diagnostic_receipt_item'
  | 'diagnostic_routing'
  | 'general';

export const attachmentService = {
  uploadFile: async (
    file: File,
    entityType: AttachmentEntityType,
    entityId: string,
    description?: string,
  ): Promise<ApiResponse<Attachment>> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('entityType', entityType);
    formData.append('entityId', entityId);
    if (description) formData.append('description', description);

    // Use a fresh axios instance for file uploads so the browser can set
    // the correct multipart/form-data boundary automatically.
    // The default httpService has Content-Type: application/json which breaks file parsing.
    const API_BASE_URL = `${ENV.VITE_API_URL}${ENV.VITE_API_BASE_PATH || '/api/v1'}`;
    const response = await axios.post<ApiResponse<Attachment>>(
      `${API_BASE_URL}/attachments/upload`,
      formData,
      {
        withCredentials: true,
        timeout: 60000,
      },
    );
    return response.data;
  },

  getAttachments: (entityType: AttachmentEntityType, entityId: string): Promise<ApiResponse<Attachment[]>> => {
    const params = new URLSearchParams();
    params.append('entityType', entityType);
    params.append('entityId', entityId);
    return get<Attachment[]>(`/attachments?${params.toString()}`);
  },

  getDownloadUrl: (id: string): Promise<ApiResponse<{ downloadUrl: string }>> => {
    return get<{ downloadUrl: string }>(`/attachments/${id}/download-url`);
  },

  deleteAttachment: (id: string): Promise<ApiResponse<null>> => {
    return del<null>(`/attachments/${id}`);
  },
};
